<template>
  <section>
    <h4>Obrigado, agora informe os dados de pagamento</h4>
    <form
      :aria-busy="loading ? 'true' : 'false'"
      :data-busy-message="dataBusyMessage"
      @submit.prevent="validateForm"
    >
      <fieldset>
        <div
          :class="`input-wrapper
					${validation.errors.name ? 'has-error' : ''}`"
        >
          <label for="number">Nome impresso no cartão de crédito</label>
          <input
            v-model="name"
            v-focus
            type="text"
            name="number"
            required
          >
          <div
            v-if="validation.errors.name"
            class="error"
          >
            {{ validation.errors.name }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.name ? 'has-error' : ''}`"
        >
          <label for="number">CPF</label>
          <input
            v-model="cpf"
            v-mask="'###.###.###-##'"
            type="tel"
            name="number"
            required
          >
          <div
            v-if="validation.errors.cpf"
            class="error"
          >
            {{ validation.errors.cpf }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.number ? 'has-error' : ''}`"
        >
          <label for="number">Número do cartão de crédito</label>
          <input
            v-model="number"
            v-mask="'#### #### #### ####'"
            type="tel"
            name="number"
            required
          >
          <div
            v-if="validation.errors.number"
            class="error"
          >
            {{ validation.errors.number }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.validity_month ? 'has-error' : ''}`"
        >
          <label for="validity_month">Mês</label>
          <input
            v-model="validity_month"
            v-mask="'##'"
            type="tel"
            name="validity_month"
            placeholder="MM"
            required
          >
          <div
            v-if="validation.errors.validity_month"
            class="error"
          >
            {{ validation.errors.validity_month }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.validity_year ? 'has-error' : ''}`"
        >
          <label for="validity_year">Ano</label>
          <input
            v-model="validity_year"
            v-mask="'####'"
            type="tel"
            name="validity_year"
            placeholder="AAAA"
            required
          >
          <div
            v-if="validation.errors.validity_year"
            class="error"
          >
            {{ validation.errors.validity_year }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.csc ? 'has-error' : ''}`"
        >
          <label for="csc">Cód. Segurança</label>
          <input
            v-model="csc"
            type="tel"
            name="csc"
            maxlength="4"
            required
          >
          <div
            v-if="validation.errors.csc"
            class="error"
          >
            {{ validation.errors.csc }}
          </div>
        </div>
      </fieldset>
      <p
        v-if="errorMessage != ''"
        class="error"
      >
        {{ errorMessage }}
      </p>
      <p class="form__disclaimer">
        Será enviado um recibo em seu e-mail com todos os dados sobre a doação.
      </p>
      <p class="form__disclaimer">
        Não armazenamos seus dados de cartão de crédito.
      </p>
      <a
        class="donation-nav donation-nav--rewind"
        href="#"
        @click.prevent="goBack"
      >voltar</a>
      <button
        class="donation-nav donation-nav--forward bigger"
        type="submit"
        :disabled="loading"
      >
        doar!
      </button>
    </form>
  </section>
</template>

<script>
import { mask } from 'vue-the-mask';
import { validate, removeAccented } from '../../utilities';

export default {
	name: 'CardData',
	directives: {
		mask,
	},
	data() {
		return {
			loading: false,
      dataBusyMessage: '',
			errorMessage: '',
			name: '',
			cpf: '',
			csc: '',
			number: '',
			validity_month: '',
			validity_year: '',
			brand: '',
			validation: {
				errors: {},
			},
		};
	},
	computed: {
		username() {
			return this.$store.state.username;
		},
		paymentData() {
			return this.$store.state.paymentData;
		}
	},
	mounted() {
		this.scrollToDonate();
	},
	methods: {
		goBack() {
			this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'userData' });
		},
		scrollToDonate() {
			const form = document.getElementById('doar');
			form.scrollIntoView({ block: 'start', behavior: 'smooth' });
		},
    toggleLoading(message = '') {
      this.loading = !this.loading;

      this.dataBusyMessage = this.dataBusyMessage !== message
        ? message
        : '';
    },
		validateForm() {
			this.toggleLoading('Validando dados de pagamento...');

			const {
				name,
				cpf,
				csc,
				number,
				validity_year,
				validity_month,
			} = this;

			const fields = {
				name,
				cpf,
				csc,
				number,
				validity_year,
				validity_month,
			};

			const validation = validate(fields);
			const validationCPF = {
				cpf,
			};

			if (validation.valid && this.validateSessionData(validationCPF.cpf)) {
				this.saveCard({
					name: removeAccented(name),
					csc,
					number: number.replace(/\s+/g, ''),
					validity_year,
					validity_month,
					});
			} else {
				this.validation = validation;
				this.toggleLoading();
			}
		},
		validateSessionData(cpf) {
			const dataSession = JSON.parse(sessionStorage.getItem('doner-data'));

			if(this.paymentData.cpf !== cpf) {
				this.errorMessage = "O CPF do titular do cartão deve ser o mesmo informado no formulário anterior";
				setTimeout(() => {
					this.errorMessage = "";
				}, 5000);
				return false;
			}
			return true;
		},
		saveCard(card) {
			const cc_hash = this.getCardHash(card.number);

			const cc = Iugu.CreditCard(
				card.number,
				card.validity_month,
				card.validity_year,
				this.username.name,
				this.username.surname,
				card.csc);

			Iugu.createPaymentToken(cc, (response) => {
				if (response.errors) {

					this.toggleLoading();
					this.errorMessage =  'Por favor, verifique os dados do cartão de crédito';
				} else {
					const payload = {
						cc_hash,
						id: response.id,
						cpf: this.cpf,
						name: this.name,
					}
          this.$store.dispatch('START_DONATION', payload)
            .then((response)=>{
              sessionStorage.clear();
            }).catch((err) => {
                this.toggleLoading();
                this.handleErrorMessage(err);
						});
				}
			})
		},
		handleErrorMessage(err) {
			this.errorMessage = err.data[0].message;
		},
		getCardHash(number) {
			const fp = new VotolegalFP({
				excludeUserAgent: true,
				dontUseFakeFontInCanvas: true
			});

			const hash = fp.x64hash128(number, 31);
			return hash;
		}
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/cardData.vue